import type { ConfigEnvironment, ConfigInput, HostOptions } from '../contracts';
function readProfileText(source: ConfigEnvironment, key: string) {
  const value = source?.[key];
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).trim();
}

function readProfileArray(source: ConfigEnvironment, key: string) {
  const value = source?.[key];
  return Array.isArray(value) ? value : [];
}

function readProfileArrayAny(source: ConfigEnvironment, keys: string[] = []) {
  return keys
    .map((key) => readProfileArray(source, key))
    .find((value) => value.length > 0) || [];
}

function readProfileObject(source: ConfigEnvironment, key: string) {
  const value = source?.[key];
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function normalizeAppProfileConfig(appProfile: ConfigEnvironment = {}) {
  const source = appProfile && typeof appProfile === 'object' && !Array.isArray(appProfile)
    ? appProfile
    : {};
  return {
    userId: readProfileText(source, 'userId'),
    instanceId: readProfileText(source, 'instanceId'),
    domainPackDomain: readProfileText(source, 'domainPackDomain'),
    domainPackVersion: readProfileText(source, 'domainPackVersion'),
    branding: readProfileObject(source, 'branding'),
    instanceProfile: readProfileObject(source, 'instanceProfile'),
    displayPolicy: readProfileObject(source, 'displayPolicy'),
    starterScenarios: readProfileArray(source, 'starterScenarios'),
    composerModeOptions: readProfileArray(source, 'composerModeOptions'),
    capabilityCatalog: readProfileArray(source, 'capabilityCatalog'),
    modulePromptRegistry: readProfileArrayAny(source, ['modulePromptRegistry', 'module_prompt_registry']),
  };
}

export function mergeAppProfileDefaults(appProfile: ConfigEnvironment = {}, defaults: ConfigInput['defaults'] = {}): NonNullable<ConfigInput['defaults']> {
  return {
    ...normalizeAppProfileConfig(appProfile) as HostOptions,
    ...(defaults && typeof defaults === 'object' && !Array.isArray(defaults) ? defaults : {}),
  };
}
